import { useDispatch } from 'react-redux';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import { CRO_LEAD_TABLE_HEAD_2026 } from '../../../../components/datagrid/CRM/CrmLead/CRotablehead';
import { useSelector } from 'react-redux';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getCroLeadsAll } from '../../../../redux/features/croSlice';
import dayjs from 'dayjs';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import { Box, Button, Stack } from '@mui/material';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import OGARemarksContent from '../../../crd/myworkspace/NewAdmissionRegister/components/OGARemarksContent';
import ActionDrawer from '../../../../components/CustomTableWithPagination/ActionDrawer';
import CROStudentStatus from '../CROleads/CROStudentStatus';
import CourseEnrollment from '../CROleads/CourseEnroll';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useNavigate } from 'react-router-dom';
import CartEditRequest from '../../../cartEdit/CartEditRequest';

export default function CroLeads2026() {
  const dispatch = useDispatch();
  const { croLeadsAll, loading } = useSelector((state) => state.cro);
  const [fromDate, setFromDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('year').format('YYYY-MM-DD'));

  const navigate = useNavigate();

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    hiddenColumns: [],
  });
  const [actionDrawerOpen, setActionDrawerOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const dispatchParams = useMemo(
    () => ({
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
      fromDate,
      toDate,
    }),
    [tableState?.page, tableState?.pageSize, tableState?.search, fromDate, toDate],
  );

  useEffect(() => {
    dispatch(getCroLeadsAll(dispatchParams));
  }, [dispatchParams, dispatch]);

  const actionListItems = [
    {
      label: 'Student Status',
      component: ({ row }) => {
        return <CROStudentStatus rowData={row} dispatchdata={dispatchParams} />;
      },
    },
    {
      component: ({ row }) => (
        <CourseEnrollment
          courseenrollmentId={row?.course_enrollment_id}
          studentStatus={row?.student_status}
          FeePersession={row?.sroFeePerSession}
          dispatchdata={dispatchParams}
        />
      ),

      label: '',
    },
    {
      label: '',
      component: ({ row }) => (
        <Box>
          <Button
            sx={{
              p: '7px',
              px: '10px',
              background: 'linear-gradient(135deg, rgb(62, 72, 106), rgb(134, 105, 241))',
              color: '#fff',
              '&:hover': {
                background: 'linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(62, 108, 177, 0.74))',
              },
            }}
            onClick={() =>
              navigate(
                `/my-workspace/session-preference?courseenrollmentId=${row?.course_enrollment_id}&studentname=${row?.name}&course=${row?.assigned_course_name}&phone=${row?.contactNumber}`,
              )
            }
            disabled={row?.isEnrolled === false}
          >
            <Icon icon="healthicons:i-schedule-school-date-time" width="20" height="20" />
            Add Session Preference
          </Button>
        </Box>
      ),
    },
    {
      label: 'Cart Edit',
      component: ({ row }) => (
        <CartEditRequest
          courseenrollmentId={row?.course_enrollment_id}
          dispatchdata={dispatchParams}
          row={row}
          requestSection={true}
        />
      ),
    },
  ];

  const handleRowDrawer = useCallback((clickedRow) => {
    setSelectedRow(clickedRow);
    setActionDrawerOpen(true);
  }, []);

  const [modalState, setModalState] = useState({
    actionKey: '',
    row: null,
  });

  const modalConfigs = useMemo(
    () => [
      {
        actionKey: 'OGA Remarks',
        title: 'OGA Remarks',
        maxWidth: 'lg',
        render: ({ row }) => (
          <OGARemarksContent
            CROAssignID={row?.cro_assignment_id}
            name={row?.name}
            contactNumber={row?.contactNumber}
            classType={row?.class}
            course={row?.assigned_course_name}
          />
        ),
      },
    ],
    [],
  );

  const handleButtonActionClick = useCallback((actionKey, row, actionType) => {
    if (!actionKey || !row) return;
    else {
      setModalState({
        actionKey,
        row,
      });
    }
  }, []);

  const activeConfig = useMemo(() => {
    if (!modalState.actionKey || !modalState.row) return null;
    return modalConfigs.find((c) => c?.actionKey === modalState.actionKey) || null;
  }, [modalConfigs, modalState.actionKey, modalState.row]);

  return (
    <GlobalWrapper title={'CRO Leads'}>
      <Stack gap={2}>
        <FromAndToDatePicker
          fromLabel="From Date"
          toLabel="To Date"
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />

        <GlobalTable
          rowUniqueId="sl_no"
          headers={CRO_LEAD_TABLE_HEAD_2026}
          rows={croLeadsAll.data}
          meta={croLeadsAll?.meta}
          loading={loading}
          tableState={tableState}
          setTableState={setTableState}
          onButtonActionClick={handleButtonActionClick}
          actionDrawerRequired={true}
          onRowActionDrawerClick={handleRowDrawer}
          selectedRowUniqueId={actionDrawerOpen ? selectedRow?.sl_no : null}
          exportParams={{ ...dispatchParams, page: 1, limit: 'no' }}
          exportApi={getCroLeadsAll}
        />
      </Stack>
      <GlobalDialog
        title={activeConfig?.title}
        open={Boolean(modalState?.actionKey)}
        setOpen={(val) => {
          if (!val) setModalState({ actionKey: '', row: null });
        }}
        closeButton={true}
        content={activeConfig?.render ? activeConfig.render({ row: modalState?.row }) : null}
        maxWidth={activeConfig?.maxWidth || 'md'}
        fullWidth={true}
      />
      <ActionDrawer
        drawerDisplayName={selectedRow?.student_name}
        open={actionDrawerOpen}
        row={selectedRow}
        actions={actionDrawerOpen ? actionListItems : []}
        onClose={() => {
          setActionDrawerOpen(false);
          setSelectedRow(null);
        }}
      />
    </GlobalWrapper>
  );
}
